//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import TooltipIcon from '../common/TooltipIcon.vue';
import SumoDaySvg from '../../../static/images/svg/sumo_day_2022.svg';

moment.extend(relativeTime);

export default {
  name: 'DealBannerContent',
  components: {
    TooltipIcon,
  },
  props: {
    bannerDetails: {
      type: Object,
      required: true,
    },
    tooltipId: {
      type: String,
      required: true,
    },
  },
  computed: {
    svgSrc() {
      if (this.bannerDetails.svg === 'sumo day') {
        return SumoDaySvg;
      }

      return null;
    },
  },
  created() {
    this.bannerText = this.bannerDetails?.text;
    if (this.bannerDetails?.text === 'Ending soon') {
      this.bannerText = `Offer ends ${moment(this.bannerDetails.endDate).fromNow()}`;
    }
  },
};
